const access = {
  entities: [
    { label: 't(Forms)', code: 'forms' }
  ], 
  rights: [] 
}

export default access
